module.exports = __webpack_public_path__ + "static/pillow-1-28e00e9d8f08420f88b8e8786bc72373.webp";